/**
 * The wordmark. One definition, used in the sidebar, the mobile drawer, and the login page, so
 * the three cannot drift apart.
 */

import { faChartColumn } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { cn } from '@/lib/utils';

export function Brand({
  className,
  onShell = false,
}: {
  className?: string;
  /** Light-on-dark for the legacy slate sidebar / top bar. */
  onShell?: boolean;
}) {
  return (
    <span className={cn('flex items-center gap-2', className)}>
      <FontAwesomeIcon
        icon={faChartColumn}
        className={cn('text-base', onShell ? 'text-shell-foreground' : 'text-primary')}
        aria-hidden
      />
      <span className="flex flex-col leading-none">
        <span
          className={cn(
            'text-lg font-semibold tracking-tight',
            onShell && 'text-shell-foreground',
          )}
        >
          WinSight
        </span>
        <span
          className={cn(
            'mt-0.5 text-[10px] leading-tight',
            onShell ? 'text-shell-muted' : 'text-muted-foreground',
          )}
        >
          Enterprise Reporting
        </span>
      </span>
    </span>
  );
}
